import React, { useState } from 'react';
import StoreBadge from '../../components/StoreBadge/StoreBadge';

let atob;
if (typeof Buffer === 'undefined') {
    atob = require('base-64').decode;
}

export function checkToken(token) {
    const base64Payload = token.split('.')[1];
    if (!base64Payload) return false;

    let payloadJson;

    if (typeof Buffer !== 'undefined') {
        payloadJson = Buffer.from(base64Payload, 'base64').toString('utf8');
    } else if (atob) {
        payloadJson = atob(base64Payload);
    } else {
        console.warn('No base64 decoder available');
        return false;
    }

    const payload = JSON.parse(payloadJson);

    return payload;

}

export const PersonalInformation = ({ }) => {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [utility, setOther] = useState(false)
    const [utility_selected, setUtilityTariffOptions] = useState([])

    // Validation functions for each field
    const validate = (name, value) => {
        switch (name) {
            case "first-name":
                if (!value) return "First name is required.";
                if (value.length < 2) return "First name must be at least 2 characters.";
                if (!/^[A-Za-z\s\-']+$/.test(value)) return "First name should only contain letters, spaces, hyphens, or apostrophes.";
                break;
            case "last-name":
                if (!value) return "Last name is required.";
                if (value.length < 2) return "Last name must be at least 2 characters.";
                if (!/^[A-Za-z\s\-']+$/.test(value)) return "Last name should only contain letters, spaces, hyphens, or apostrophes.";
                break;
            case "your_email":
                if (!value) return "Email is required.";
                if (!/^[^@]+@[^@]+\.[a-zA-Z]{2,6}$/.test(value)) return "Please enter a valid email address.";
                break;
            case "phone":
                if (!value) return "Phone number is required.";
                if (!/^\+?1?\s?(\d{3}[-\s]?){2}\d{4}$/.test(value)) return "Please enter a valid US phone number.";
                break;
            case "password":
                if (!value) return "Password is required.";
                if (value.length < 8) return "Password must be at least 8 characters.";
                if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) return "Password must contain at least one uppercase letter, one lowercase letter, and one number.";
                break;
            case "confirm-password":
                if (!value) return "Confirm password is required.";
                if (value !== fields.password) return "Passwords do not match.";
                break;
            default:
                return "";
        }
        return "";
    };

    // Store field values in state
    const [fields, setFields] = useState({
        "first-name": "",
        "last-name": "",
        "your_email": "",
        "phone": "",
        "password": "",
        "confirm-password": ""
    });

    const handleBlur = (e) => {
        const { name, value } = e.target;
        setTouched(prev => ({ ...prev, [name]: true }));
        setErrors(prev => ({ ...prev, [name]: validate(name, value) }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
        if (touched[name]) {
            setErrors(prev => ({ ...prev, [name]: validate(name, value) }));
        }
        // Also revalidate confirm password when password changes
        if (name === "password" && touched["confirm-password"]) {
            setErrors(prev => ({ ...prev, "confirm-password": validate("confirm-password", fields["confirm-password"]) }));
        }
    };

    const errorStyle = { borderColor: 'red' };
    const errorMsgStyle = { color: 'red', fontSize: '0.9em', marginTop: 2 };

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Personal Information</h3>
                        <p>Please enter your information and proceed to the next step so we can build your account.</p>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <fieldset>
                                <legend>First Name</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="first-name"
                                    name="first-name"
                                    placeholder="First Name"
                                    required
                                    minLength={2}
                                    maxLength={50}
                                    pattern="^[A-Za-z\s\-']+$"
                                    title="First name should only contain letters, spaces, hyphens, or apostrophes."
                                    value={fields["first-name"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["first-name"] && touched["first-name"] ? errorStyle : undefined}
                                />
                                {errors["first-name"] && touched["first-name"] && (
                                    <div style={errorMsgStyle}>{errors["first-name"]}</div>
                                )}
                            </fieldset>
                        </div>
                        <div className="form-holder">
                            <fieldset>
                                <legend>Last Name</legend>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="last-name"
                                    name="last-name"
                                    placeholder="Last Name"
                                    required
                                    minLength={2}
                                    maxLength={50}
                                    pattern="^[A-Za-z\s\-']+$"
                                    title="Last name should only contain letters, spaces, hyphens, or apostrophes."
                                    value={fields["last-name"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["last-name"] && touched["last-name"] ? errorStyle : undefined}
                                />
                                {errors["last-name"] && touched["last-name"] && (
                                    <div style={errorMsgStyle}>{errors["last-name"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Phone Number</legend>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    name="phone"
                                    placeholder="+1 888-999-7777"
                                    required
                                    pattern="^\+?1?\s?(\d{3}[-\s]?){2}\d{4}$"
                                    maxLength={20}
                                    title="Please enter a valid US phone number."
                                    value={fields["phone"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["phone"] && touched["phone"] ? errorStyle : undefined}
                                />
                                {errors["phone"] && touched["phone"] && (
                                    <div style={errorMsgStyle}>{errors["phone"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Your Email</legend>
                                <input
                                    type="email"
                                    name="your_email"
                                    id="your_email"
                                    className="form-control"
                                    pattern="^[^@]+@[^@]+\.[a-zA-Z]{2,6}$"
                                    placeholder="example@email.com"
                                    required
                                    maxLength={100}
                                    title="Please enter a valid email address."
                                    value={fields["your_email"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["your_email"] && touched["your_email"] ? errorStyle : undefined}
                                />
                                {errors["your_email"] && touched["your_email"] && (
                                    <div style={errorMsgStyle}>{errors["your_email"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Password</legend>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    placeholder="Password"
                                    required
                                    minLength={8}
                                    maxLength={50}
                                    title="Password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, and one number."
                                    value={fields["password"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["password"] && touched["password"] ? errorStyle : undefined}
                                />
                                {errors["password"] && touched["password"] && (
                                    <div style={errorMsgStyle}>{errors["password"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-holder form-holder-2">
                            <fieldset>
                                <legend>Confirm Password</legend>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirm-password"
                                    name="confirm-password"
                                    placeholder="Confirm Password"
                                    required
                                    minLength={8}
                                    maxLength={50}
                                    title="Please confirm your password."
                                    value={fields["confirm-password"]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={errors["confirm-password"] && touched["confirm-password"] ? errorStyle : undefined}
                                />
                                {errors["confirm-password"] && touched["confirm-password"] && (
                                    <div style={errorMsgStyle}>{errors["confirm-password"]}</div>
                                )}
                            </fieldset>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};


export const Confirmation = ({ data }) => {
    // Check if any required field is empty
    const isIncomplete =
        !data.first_name ||
        !data.last_name ||
        !data.email ||
        !data.phone_number;

    if (isIncomplete) {
        return (
            <div>
                <section>
                    <div className="inner">
                        <div className="wizard-header">
                            <h3 className="heading">Confirmation</h3>
                            <p style={{ color: 'red' }}>Please complete your Personal Information</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header">
                        <h3 className="heading">Confirmation</h3>
                        <p>Please review your information below before proceeding.</p>
                        <p>Click Sign Up to proceed to the next steps</p>
                    </div>
                    <div className="form-row">
                        <div className="form-holder">
                            <h4>Personal Information</h4>
                            <p><strong>First Name:</strong> {data.first_name}</p>
                            <p><strong>Last Name:</strong> {data.last_name}</p>
                            <p><strong>Email:</strong> {data.email}</p>
                            <p><strong>Phone Number:</strong> {data.phone_number}</p>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};

export const SuccessfulEnrollment = ({ enrollmentSubmitted }) => {
    // Check if any required field is empty

    return (
        <div>
            <section>
                <div className="inner">
                    {/* Wizard header content */}
                    {enrollmentSubmitted.status == 'success' && (
                        <div className="wizard-header">
                            <h3 className="heading">Continue Enrollment on Mobile App</h3>
                            <p>We have sent you an email to continue your enrollment</p>
                            <p>Please use the link to download the mobile app. Then use the QR provided here or the button to resume your enrollment.</p>
                        </div>
                    )}
                    {enrollmentSubmitted.status == 'waitlisted' && (
                        <div className="wizard-header">
                            <h3 className="heading">Waitlisted - Download the App</h3>
                            <p>Due to high volume, you have been placed on our waitlist.</p>
                            <p>In the meantime, please download the Gridient mobile app using the links below. We will notify you via email as soon as your enrollment can proceed.</p>
                            <p>Thank you for your patience!</p>
                        </div>
                    )}
                    {/* Download Gridient section below header */}
                    <div className="storebadge-inline">
                        <h3 style={{ marginTop: 0, marginBottom: 10 }}>Download Gridient!</h3>
                        <StoreBadge
                            name="Gridient"
                            googlePlayUrl="https://play.google.com/store/apps/details?id=com.gridient"
                            appStoreUrl="https://apps.apple.com/app/id6747466420"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};  